const getMissingDependencyText = (dependency) => {
	if (dependency.toLowerCase().includes('quote')) {
		return 'Please upload a quote document in the Quotes tab.';
	}
	if (dependency.toLowerCase().includes('risk')) {
		return 'Please upload a risk info document in the Risk Info tab.';
	}
	return '';
};

/**
 * The menu item caption for summary types the deal has no message for yet.
 *
 * @param {string[]} missingSummaryTypes
 * @returns {string}
 */
export const getMissingDependenciesMessage = (missingSummaryTypes) =>
	`Missing dependencies. ${missingSummaryTypes
		.map(getMissingDependencyText)
		.filter(Boolean)
		.join(' ')}`;
